module.exports = {
    RESERVED_PRIMITIVES: ["cuboid", "cone", "cylinder", "plane"],
    DEFAULT_TAG: "latest",
    MONGODB_COLLECTION_MODELS: "test",
    MONGODB_COLLECTION_TAGS: "tags",
}
